export default {
  en: {
    "admin.heading.userprofile": "User Profile",
    "admin.heading.changepassword": "Change Password",
    "admin.button.Activitylog": "Activity Log",
    "admin.heading.usertype": "User Type",
    "admin.heading.username": "User Name",
    "admin.heading.entityname": "Entity Name",
    "admin.heading.status": "Status",
    "admin.heading.primaryemail": "Primary Email",
    "admin.heading.userrole": "User Role",
    "admin.heading.role": "Role",
    "admin.heading.description": "Description",
    "admin.input.password": "New Password",
    "admin.input.repeatpassword": "Confirm New Password",
    "admin.heading.reset": "Reset",
    "admin.button.submit": "Submit",
  },
  fr: {
    "admin.heading.userprofile": "Profil utilisateur",
    "admin.heading.changepassword": "Changer le mot de passe",
    "admin.button.Activitylog": "Journal d'activité",
    "admin.heading.usertype": "Type d'utilisateur",
    "admin.heading.username": "Nom d'utilisateur",
    "admin.heading.entityname": "Nom de l'entité",
    "admin.heading.status": "Statut",
    "admin.heading.primaryemail": "Email principal",
    "admin.heading.userrole": "Rôle utilisateur",
    "admin.heading.role": "Rôle",
    "admin.heading.description": "Description",
    "admin.input.password": "Nouveau mot de passe",
    "admin.input.repeatpassword": "Confirmez le nouveau mot de passe",
    "admin.heading.reset": "Réinitialiser",
    "admin.button.submit": "Soumettre",
  },
  es: {
    "admin.heading.userprofile": "Perfil del usuario",
    "admin.heading.changepassword": "Cambiar la contraseña",
    "admin.button.Activitylog": "Registro de actividad",
    "admin.heading.usertype": "Tipo de usuario",
    "admin.heading.username": "Nombre de usuario",
    "admin.heading.entityname": "Nombre de la entidad",
    "admin.heading.status": "Estado",
    "admin.heading.primaryemail": "Correo electrónico principal",
    "admin.heading.userrole": "Rol de usuario",
    "admin.heading.role": "Rol",
    "admin.heading.description": "Descripción",
    "admin.input.password": "Nueva contraseña",
    "admin.input.repeatpassword": "Confirmar nueva contraseña",
    "admin.heading.reset": "Restablecer",
    "admin.button.submit": "Enviar",
  },
  pt: {
    "admin.heading.userprofile": "Perfil do usuário",
    "admin.heading.changepassword": "Alterar senha",
    "admin.button.Activitylog": "Registro de atividades",
    "admin.heading.usertype": "Tipo de usuário",
    "admin.heading.username": "Nome de usuário",
    "admin.heading.entityname": "Nome da entidade",
    "admin.heading.status": "Status",
    "admin.heading.primaryemail": "Email principal",
    "admin.heading.userrole": "Função de usuário",
    "admin.heading.role": "Função",
    "admin.heading.description": "Descrição",
    "admin.input.password": "Nova senha",
    "admin.input.repeatpassword": "Confirmar nova senha",
    "admin.heading.reset": "Redefinir",
    "admin.button.submit": "Enviar",
  },
  zh_CN: {
    "admin.heading.userprofile": "用户资料",
    "admin.heading.changepassword": "更改密码",
    "admin.button.Activitylog": "活动日志",
    "admin.heading.usertype": "用户类型",
    "admin.heading.username": "用户名",
    "admin.heading.entityname": "实体名称",
    "admin.heading.status": "状态",
    "admin.heading.primaryemail": "主要电子邮件",
    "admin.heading.userrole": "用户角色",
    "admin.heading.role": "角色",
    "admin.heading.description": "描述",
    "admin.input.password": "新密码",
    "admin.input.repeatpassword": "确认新密码",
    "admin.heading.reset": "重置",
    "admin.button.submit": "提交",
  },
  hi: {
    "admin.heading.userprofile": "उपयोगकर्ता प्रोफ़ाइल",
    "admin.heading.changepassword": "पासवर्ड बदलें",
    "admin.button.Activitylog": "गतिविधि लॉग",
    "admin.heading.usertype": "उपयोगकर्ता प्रकार",
    "admin.heading.username": "उपयोगकर्ता नाम",
    "admin.heading.entityname": "संस्था का नाम",
    "admin.heading.status": "स्थिति",
    "admin.heading.primaryemail": "प्राथमिक ईमेल",
    "admin.heading.userrole": "उपयोगकर्ता भूमिका",
    "admin.heading.role": "भूमिका",
    "admin.heading.description": "विवरण",
    "admin.input.password": "नया पासवर्ड",
    "admin.input.repeatpassword": "नया पासवर्ड पुष्टि करें",
    "admin.heading.reset": "रीसेट",
    "admin.button.submit": "जमा करें",
  },
  ka: {
    "admin.heading.userprofile": "ಬಳಕೆದಾರ ಪ್ರೊಫೈಲ್",
    "admin.heading.changepassword": "ಪಾಸ್ವರ್ಡ್ ಬದಲಾಯಿಸಿ",
    "admin.button.Activitylog": "ಸಕ್ರಿಯತಾ ದಿನಚರಿ",
    "admin.heading.usertype": "ಬಳಕೆದಾರ ಪ್ರಕಾರ",
    "admin.heading.username": "ಬಳಕೆದಾರ ಹೆಸರು",
    "admin.heading.entityname": "ಘಟಕದ ಹೆಸರು",
    "admin.heading.status": "ಸ್ಥಿತಿ",
    "admin.heading.primaryemail": "ಪ್ರಾಥಮಿಕ ಇಮೇಲ್",
    "admin.heading.userrole": "ಬಳಕೆದಾರರ ಪಾತ್ರ",
    "admin.heading.role": "ಪಾತ್ರ",
    "admin.heading.description": "ವಿವರಣೆ",
    "admin.input.password": "ಹೊಸ ಪಾಸ್ವರ್ಡ್",
    "admin.input.repeatpassword": "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
    "admin.heading.reset": "ಮರುಹೊಂದಿಸಿ",
    "admin.button.submit": "ಸಲ್ಲಿಸು",
  },
  lo: {
    "admin.heading.userprofile": "ໂປຣໄຟລຜູ້ໃຊ້",
    "admin.heading.changepassword": "ປ່ຽນລະຫັດຜ່ານ",
    "admin.button.Activitylog": "ບັນທຶກການກະທຳ",
    "admin.heading.usertype": "ປະເພດຜູ້ໃຊ້",
    "admin.heading.username": "ຊື່ຜູ້ໃຊ້",
    "admin.heading.entityname": "ຊື່ເອກະກອນ",
    "admin.heading.status": "ສະຖານະ",
    "admin.heading.primaryemail": "ອີເມວຫຼັກ",
    "admin.heading.userrole": "ບົດບາດຜູ້ໃຊ້",
    "admin.heading.role": "ບົດບາດ",
    "admin.heading.description": "ຄໍາອະທິບາຍ",
    "admin.input.password": "ລະຫັດໃໝ່",
    "admin.input.repeatpassword": "ຢືນຢັນລະຫັດໃໝ່",
    "admin.heading.reset": "ປັບຄືນ",
    "admin.button.submit": "ຍື່ນ",
  },
  my_MM: {
    "admin.heading.userprofile": "အသုံးပြုသူ ကိုယ်ရေးအကျဉ်း",
    "admin.heading.changepassword": "စကားဝှက်ပြောင်းပါ",
    "admin.button.Activitylog": "လှုပ်ရှားမှု မှတ်တမ်း",
    "admin.heading.usertype": "အသုံးပြုသူအမျိုးအစား",
    "admin.heading.username": "အသုံးပြုသူအမည်",
    "admin.heading.entityname": "အဖွဲ့အစည်း အမည်",
    "admin.heading.status": "အခြေအနေ",
    "admin.heading.primaryemail": "အဓိက အီးမေးလ်",
    "admin.heading.userrole": "အသုံးပြုသူ တာဝန်",
    "admin.heading.role": "အခန်းကဏ္ဍ",
    "admin.heading.description": "ဖော်ပြချက်",
    "admin.input.password": "စကားဝှက်အသစ်",
    "admin.input.repeatpassword": "စကားဝှက်အသစ်အတည်ပြုပါ",
    "admin.heading.reset": "ပြန်လည်သတ်မှတ်ပါ",
    "admin.button.submit": "တင်ပါ",
  },
  my: {
    "admin.heading.userprofile": "Profil pengguna",
    "admin.heading.changepassword": "Tukar kata laluan",
    "admin.button.Activitylog": "Log Aktiviti",
    "admin.heading.usertype": "Jenis pengguna",
    "admin.heading.username": "Nama pengguna",
    "admin.heading.entityname": "Nama entiti",
    "admin.heading.status": "Status",
    "admin.heading.primaryemail": "E-mel utama",
    "admin.heading.userrole": "Peranan pengguna",
    "admin.heading.role": "Peranan",
    "admin.heading.description": "Penerangan",
    "admin.input.password": "Kata laluan baharu",
    "admin.input.repeatpassword": "Sahkan kata laluan baharu",
    "admin.heading.reset": "Tetapkan semula",
    "admin.button.submit": "Hantar",
  },
};
